import * as React from 'react';

export default function useHeader() {
  const [hasScroll, setHasScroll] = React.useState(false);

  React.useEffect(() => {
    const handleOnScroll = () => {
      let currentScrollPos = window.pageYOffset;
      if (currentScrollPos > 72) {
        setHasScroll(true);
      } else {
        setHasScroll(false);
      }
    };

    handleOnScroll();

    window.addEventListener('scroll', handleOnScroll);
    return () => {
      window.removeEventListener('scroll', handleOnScroll);
    };
  }, []);

  return [hasScroll];
}
